import { styled } from '@mui/material/styles';

export const EditorContainer = styled('div')({
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
});

export const AppliedTagsContainer = styled('div')({
    display: 'flex',
    flexWrap: 'wrap',
    gap: '4px',
});

export const AddTagIconButton = styled('div')({
    width: '24px',
    height: '24px',
    border: '1px dotted grey',
    borderRadius: '4px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
});

export const AddTagButton = styled('div')(({ theme }) => ({
    height: '24px',
    border: `1px dotted ${theme.palette.secondary.main}`,
    borderRadius: '4px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    padding: theme.spacing(0, 0.5, 0, 0.25),
    width: 'auto',
    minWidth: 'auto',
    gap: theme.spacing(0.25),
    color: theme.palette.secondary.main,
    '& .MuiTypography-root': {
        fontSize: '0.75rem',
    },
}));
